import React, { useState } from 'react';
import { Popover } from 'antd';
import FisheryMarker from '../assets/images/FisheryMarker.js';
import SearchResultCard from './SearchResultCard';
import EventMarker from '../assets/images/GetFishing Icon.svg';

export default function MapPopover(props) {
  const [visible, setVisible] = useState(false);

  const cluster = props.data;

  // const fisheryMarkerColour = visible
  //   ? 'sb-blue-900'
  //   : cluster.is_bookable
  //     ? 'sb-blue-700'
  //     : 'seagreen-700';
  const fisheryMarkerColour = 'grey';

  return (
    <Popover
      id='sb-map-popover-content'
      content={
        <div className='sb-map-popover-content'>
          <SearchResultCard
            fisheryId={cluster.id}
            name={cluster.name}
            address={`${cluster.address_one_line}`}
            thumbnail={cluster.primary_image_url}
            data={{ ...cluster, id: cluster?.private_id }}
            bookable={cluster.is_bookable}
            adminName={cluster.admin_name}
            cost={cluster.cost_in_pence}
            adminImage={cluster.admin_profile_image}
            startDate={cluster.start_date}
            startTime={cluster.start_time}
            endTime={cluster.end_time}
            timezone={cluster.timezone}
            initialIsFavourite={cluster.is_favourite}
            showDetails={false}
          />
        </div>
      }
      trigger='click'
      open={visible}
      onOpenChange={(visible) => {
        setVisible(visible);
      }}
    >
      <p className='map-fishery-marker'>
        <img
          src={EventMarker}
          width={40}
          className={fisheryMarkerColour + ' fs-40 cp'}
          id={'open-popover-' + cluster.id}
        />
      </p>
    </Popover>
  );
}
